import AuditoriaService from "service/auditoria5s/AuditoriaService";
import { useEffect, useState } from "react";
import { ChartBarModel } from "model/chart/ChartBarModel";
import ChartBarHorizontal from "components/chart/ChartBarHorizontal";
import ChartBar from "components/chart/ChartBar";
import { Button } from "primereact/button";
import saveAs from 'file-saver';
import { Panel } from "primereact/panel";
import { useLoadingContext } from "provider/LoadingProvider";

const auditoriaService = new AuditoriaService();

export default function AuditoriaDashboard() {

    const [chartNotaPorSetor, setChartNotaPorSetor] = useState<ChartBarModel>({ nameX: "", nameY: "", title: "", bars: [] });
    const [chartEvolucaoSetor, setChartEvolucaoSetor] = useState<ChartBarModel>({ nameX: "", nameY: "", title: "", bars: [] });
    const { startLoading, stopLoading } = useLoadingContext();

    useEffect(() => {
        auditoriaService.getGraficoNotaPorSetor().then(json => {
            setChartNotaPorSetor(json);
        }).catch(err => {
            console.log(err);
        });

        auditoriaService.getGraficoEvolucaoSetor().then(json => {
            setChartEvolucaoSetor(json);
        }).catch(err => {
            console.log(err);
        });

    }, []);

    function getHeader() {

        return (
            <div className="p-panel-header" style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                <div></div>
                <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative', fontWeight:700 }}>Dashboard</span>
                <div>
                    <Button
                        type="button"
                        label="Relatório"
                        onClick={() => {
                            startLoading();
                            auditoriaService.getRelatorioGeral().then(data => {
                                const file = new Blob([data], { type: 'application/pdf' });
                                saveAs(file, `Relatório de Auditorias.pdf`);
                                stopLoading();
                            }).catch(err => {
                                stopLoading();
                                console.log(err);
                            });
                        }}
                    ></Button>
                </div>
            </div>
        )
    }

    return (
        <>
            <Panel headerTemplate={getHeader()} style={{ marginBottom: 20 }} >
                <div style={{ display: "flex", flexDirection: "row", columnGap: 20, rowGap: 20, flexWrap: "wrap" }} >
                    <div style={{ width: 500, borderRadius: 20, justifyContent: 'center', alignItems: "center", backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
                        <ChartBarHorizontal
                            data={chartNotaPorSetor}
                            width={500}
                            height={chartNotaPorSetor.bars.length * 20 > 300 ? chartNotaPorSetor.bars.length * 20 : 300}
                            colorFunction={(datum) => {
                                return "#0364FF";
                            }}
                        />
                    </div>
                    <div style={{ width: 500, height: 310, borderRadius: 20, alignItems: 'center', backgroundColor: "#FFF", boxShadow: '3px 3px 10px 1px rgba(0,0,0,0.2)' }}>
                        <ChartBar
                            showTitle
                            data={chartEvolucaoSetor}
                            width={500}
                            height={250}
                            tickValues={[0, 2, 4, 6, 8, 10]}
                            colorFunction={(datum) => {
                                if (datum.datum && datum.datum.y) {
                                    if (datum.datum.y >= 8) {
                                        return "#00611F";
                                    } else if (datum.datum.y >= 6) {
                                        return "#FFBE0D";
                                    }
                                    return "red";
                                }
                                return "red";
                            }} />
                    </div>
                </div>
            </Panel>
        </>
    );
}